module.exports = __webpack_public_path__ + "static/media/bot-face.eab9e7f6.png";